<div>
  <legend>{{ 'tkey;dialplanmanagement.admin.group.dnranges.navlink' | translate }}</legend>

  <div class="row">
    <div class="col-6 d-flex flex-column">
      <!-- Label outside to allow show/hide the form -->
      <label
        [ngClass]="{
          'ziro-forms-error': extensionRangesDisplayFormValidationState === validationStates.INVALID,
          'ziro-forms-warning': extensionRangesDisplayFormValidationState === validationStates.WARNING,
        }"
        data-automation="extension-ranges-label"
        class="ziro-forms-label col-form-label"
      >
        <span class="text-danger ziro-forms-asterisk">*</span>
        <span>
          {{ 'tkey;dialplanmanagement.admin.group.dnranges' | translate }}
        </span>
      </label>
      <div class="d-flex flex-column flex-grow-1 flex-min-height-0">
        @if (displayRangeForm) {
          <ziro-extension-ranges-display-form
            data-automation="extension-ranges-display-form"
            [entity]="displayRangeFormEntity"
            [groupId]="groupId()"
            [clusterId]="clusterId()"
            [dialPlanGroups]="dialPlanGroups()"
            [siteSummary]="siteSummary()"
            [optionalValidators]="displayRangeFormOptionalValidators"
            (ziroFormsUpdate$)="onRangeFormUpdate($event)"
            class="d-flex flex-column h-100"
          ></ziro-extension-ranges-display-form>
        }
      </div>
    </div>
    <div class="col-6 d-flex flex-column justify-content-between">
      <ziro-textarea fieldId="bulkRanges"></ziro-textarea>
      <ziro-button
        [dataAutomation]="'dn-ranges-bulk-ranges-button'"
        [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
        [label]="'tkey;dialplanmanagement.admin.group.generate.button'"
        (clicked)="generateBulkRangesClicked()"
      ></ziro-button>
    </div>
  </div>
</div>

<div>
  <legend>{{ 'tkey;dialplanmanagement.admin.group.dnranges.line_appearance_settings.header' | translate }}</legend>
  <ziro-checkbox fieldId="advertise_distinct_mask_for_public_lines"></ziro-checkbox>
  <ziro-custom-input-text fieldId="external_phone_number_mask"></ziro-custom-input-text>
  <ziro-custom-input-text fieldId="public_external_phone_number_mask"></ziro-custom-input-text>
  <ziro-custom-input-text fieldId="line_text_label"></ziro-custom-input-text>
</div>

<div>
  <legend>{{ 'tkey;dialplanmanagement.admin.group.dnranges.dn.settings' | translate }}</legend>
  <ziro-custom-select fieldId="route_partition"></ziro-custom-select>
  <ziro-multi-checkbox fieldId="urgent_priority"></ziro-multi-checkbox>
  <ziro-custom-select fieldId="optional_line_group_membership"></ziro-custom-select>
  <ziro-custom-select fieldId="auto_answer"></ziro-custom-select>
  <ziro-custom-select fieldId="monitoring_calling_search_space"></ziro-custom-select>
</div>

<div>
  <legend
    (click)="isEntAltSectionVisible = !isEntAltSectionVisible"
    class="clickable-cursor"
    data-automation="dn-ranges-ent-alt-num-header"
  >
    <i [class]="isEntAltSectionVisible ? ziroIcons.SQUARE_INDETERMINATE : ziroIcons.SQUARE_PLUS"></i>
    {{ 'tkey;dialplanmanagement.admin.group.dnranges.enterprise_alternate_number.label' | translate }}
  </legend>

  <div [hidden]="!isEntAltSectionVisible">
    <ziro-custom-input-text fieldId="ent_alt_num_number_mask"></ziro-custom-input-text>
    <ziro-multi-checkbox fieldId="ent_alt_num_advertise_globally_via_ils"></ziro-multi-checkbox>
    <ziro-multi-checkbox fieldId="ent_alt_num_is_urgent"></ziro-multi-checkbox>
    <ziro-multi-checkbox fieldId="ent_alt_num_add_to_local_route_partition"></ziro-multi-checkbox>
    <ziro-custom-select fieldId="ent_alt_num_route_partition"></ziro-custom-select>
  </div>
</div>

<div>
  <legend
    (click)="isE164AltSectionVisible = !isE164AltSectionVisible"
    class="clickable-cursor"
    data-automation="dn-ranges-e164-alt-num-header"
  >
    <i [class]="isE164AltSectionVisible ? ziroIcons.SQUARE_INDETERMINATE : ziroIcons.SQUARE_PLUS"></i>
    {{ 'tkey;dialplanmanagement.admin.group.dnranges.e164_alternate_number.label' | translate }}
  </legend>

  <div [hidden]="!isE164AltSectionVisible">
    <ziro-custom-input-text fieldId="e164_alt_num_number_mask"></ziro-custom-input-text>
    <ziro-multi-checkbox fieldId="e164_alt_num_advertise_globally_via_ils"></ziro-multi-checkbox>
    <ziro-multi-checkbox fieldId="e164_alt_num_is_urgent"></ziro-multi-checkbox>
    <ziro-multi-checkbox fieldId="e164_alt_num_add_to_local_route_partition"></ziro-multi-checkbox>
    <ziro-custom-select fieldId="e164_alt_num_route_partition"></ziro-custom-select>
  </div>
</div>

<div>
  <legend
    (click)="isPstnFailoverSectionVisible = !isPstnFailoverSectionVisible"
    class="clickable-cursor"
    data-automation="dn-ranges-pstn-failover-header"
  >
    <i [class]="isPstnFailoverSectionVisible ? ziroIcons.SQUARE_INDETERMINATE : ziroIcons.SQUARE_PLUS"></i>
    {{ 'tkey;dialplanmanagement.admin.group.dnranges.pstn_failover.label' | translate }}
  </legend>

  <div [hidden]="!isPstnFailoverSectionVisible">
    <ziro-custom-select fieldId="pstn_failover"></ziro-custom-select>
  </div>
</div>

<div>
  <legend
    (click)="isVoicemailAlternateExtensionSectionVisible = !isVoicemailAlternateExtensionSectionVisible"
    class="clickable-cursor"
    data-automation="dn-ranges-voicemail-alternate-extensions-header"
  >
    <i
      [class]="isVoicemailAlternateExtensionSectionVisible ? ziroIcons.SQUARE_INDETERMINATE : ziroIcons.SQUARE_PLUS"
    ></i>
    {{ 'tkey;dialplanmanagement.admin.group.dnranges.voicemail_alternate_extension.legend' | translate }}
  </legend>

  <div [hidden]="!isVoicemailAlternateExtensionSectionVisible">
    <ziro-checkbox fieldId="enableAlternateExtension"></ziro-checkbox>
    <ziro-custom-input-text fieldId="voicemailAlternateExtension"></ziro-custom-input-text>
  </div>
</div>
